import { isDevToolsOpen } from '../detector/devtool';
import { checkPermission, PermissionType } from '../detector/permission';
import { isFunctionHooked, checkBrowserConsistency } from '../detector/check';
import type { ISecurity } from '../types';

function testLanguages() {
  return navigator.languages === undefined || navigator.languages.length === 0;
}

function testPlugins() {
  return navigator.plugins.length === 0;
}

function testScreenSize() {
  return window.screen.width < 1024 || window.screen.height < 768;
}

function testWebDriver() {
  return navigator.webdriver;
}

function testPermission() {
  return navigator.permissions === undefined;
}

function testAppVersion() {
  return /headless/i.test(navigator.appVersion);
}

function testUserAgent() {
  return /HeadlessChrome|PhantomJS|Puppeteer|Electron|Playwright/i.test(navigator.userAgent);
}

function testMimes() {
  return navigator.mimeTypes.length === 0;
}

/** Selenium console 差异 */
function testConsole() {
  return console.log.toString().includes('[native code]') === false;
}

function testNetworkRtt() {
  if (!navigator.connection?.rtt) {
    return false;
  }

  if (navigator.connection.rtt < 20) {
    return true;
  }

  return false;
}

async function isFakeGeolocation(): Promise<boolean> {
  const hasPermission = await checkPermission(PermissionType.geolocation);
  if (!hasPermission) return false;

  const isHooked = isFunctionHooked(navigator.geolocation.getCurrentPosition);
  if (isHooked) {
    return true;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(location => {
      const isFake = 
                location.coords.accuracy > 1000 || // 精度异常高
                location.coords.altitude === null || // 缺少海拔信息
                location.coords.latitude === null || // 缺少纬度
                location.coords.longitude === null; // 缺少经度
            
      resolve(isFake);
    }, () => {
      resolve(false);
    })
  })
}

export async function getSecurityInfo(): Promise<ISecurity> {
  const invliadLanguages = testLanguages();
  const invalidPlugins = testPlugins();
  const invalidScreenSize = testScreenSize();
  const isWebDriver = testWebDriver();
  const inValidPermission = testPermission();
  const inValidAppVersion = testAppVersion();
  const invalidUserAgent = testUserAgent();
  const invalidMimes = testMimes();
  const invalidConsle = testConsole();

  const isHeadlessBrowser = invliadLanguages || invalidPlugins || invalidScreenSize
                || isWebDriver || inValidPermission
                || inValidAppVersion || invalidUserAgent || invalidMimes;
  return {
    ga: isHeadlessBrowser,
    gb: isHeadlessBrowser || invalidConsle,
    gc: checkBrowserConsistency(),
    gd: '',
    ge: '',
    gf: '',
    gg: invalidPlugins,
    gh: testNetworkRtt(),
    gi: true,
    gj: '',
    gk: isDevToolsOpen() ? 'viewSize' : 'none',
    gl: '',
    gm: await isFakeGeolocation() ? 'fake' : 'none',
  }
}
